export const locale = {
    categories: { ru: "Сфера деятельности", en: "Business area" },
    stand: { ru: "Стенд", en: "Stand" },
    pavilion: { ru: "Павильон", en: "Pavilion" },

}